import { DataSource } from 'hooks/useHttpClient';
import { User, UserSingleMemberResolver } from './Users';
import { BasicMappedStatus } from './Candidate';
import { getJobRole } from './Job';
import { Company } from './Company';

export type Member = {
    // TOOD Add more fields and member logic within the relationship
    // NEED TO ADD COMPANY LATER
    id: number;
    user: User | null;
    role?: BasicMappedStatus;
    taskRole?: 'viewer' | 'owner' | 'creator' | undefined;
};

export type FastMemberOption = {
    option: BasicMappedStatus;
    id: number;
    name: string;
    jobTitle?: string | null;
    companyId: number;
    companyName: string;
    role?: BasicMappedStatus;
    taskRole?: 'viewer' | 'owner' | 'creator' | undefined;
};

export function FastMemberOptionListResolver(dataSource: DataSource, apiResponse: any): FastMemberOption[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    option: {
                        id: member.id,
                        name: `${member.name} - ${member.company_name}`
                    },
                    id: member.id,
                    name: member.name,
                    jobTitle: member.job_title || undefined,
                    companyId: member.company_id,
                    companyName: member.company_name
                }));

            default:
                return [];
        }
    } catch (error) {
        return [];
    }
}

export function MemberListResolver(dataSource: DataSource, apiResponse: any): Member[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    id: member.id, // TODO This would be a intermediate table some day
                    user: UserSingleMemberResolver(dataSource, member),
                    role: getJobRole(member.role_id, member.role || member.job_title || undefined)
                }));

            default:
                return [];
        }
    } catch (error) {
        return [];
    }
}

export function MemberListFromJobResolver(dataSource: DataSource, apiResponse: any, preferJobTitle: boolean = false): Member[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    id: member.user?.id || member.id, // TODO This would be a intermediate table some day
                    user: UserSingleMemberResolver(dataSource, member.user) || UserSingleMemberResolver(dataSource, member),
                    role: getJobRole(member.role_id || member.pivot?.role_id, member.role || member.job_title || undefined, preferJobTitle),
                    taskRole: member?.pivot?.type || undefined
                }));

            default:
                return [];
        }
    } catch (error) {
        console.log(error);
        return [];
    }
}

export function FastMemberListFromJobResolver(dataSource: DataSource, apiResponse: any, company?: Company): FastMemberOption[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    option: {
                        id: member.id,
                        name: `${member.name}${member.job_title && ` ${member.job_title}`}`
                    },
                    id: member.user?.id || member.id,
                    name: member.user?.name || `${member.user?.first_name} ${member.user?.last_name}`,
                    role: getJobRole(member.role_id || member.pivot?.role_id, member.role || member.job_title || undefined),
                    jobTitle: member.profile?.job_title || undefined,
                    companyId: member.company?.id || 0,
                    companyName: member.company?.name || ''
                }));

            default:
                return [];
        }
    } catch (error) {
        console.log(error);
        return [];
    }
}

export function MemberListFromTaskResolver(dataSource: DataSource, apiResponse: any): FastMemberOption[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    option: {
                        id: member.id,
                        name: `${member.name}${member.job_title && ` ${member.job_title}`}`
                    },
                    id: member.id,
                    name: member.name || `${member.first_name} ${member.last_name}`,
                    role: getJobRole(member.role_id, member.role || member.job_title || undefined),
                    taskRole: member.pivot.type || undefined,
                    jobTitle: member.job_title || undefined,
                    companyId: 0,
                    companyName: '' // TODO Add company later
                }));

            default:
                return [];
        }
    } catch (error) {
        return [];
    }
}

export function PossibleTaskMemberListResolver(dataSource: DataSource, apiResponse: any): Member[] {
    try {
        switch (dataSource) {
            case 'hyrerocket':
                return apiResponse.map((member: any) => ({
                    id: member.id, // TODO This would be a intermediate table some day
                    user: UserSingleMemberResolver(dataSource, member),
                    role: getJobRole(member.role_id, member.role || member.job_title || undefined)
                }));

            default:
                return [];
        }
    } catch (error) {
        console.log(error);
        return [];
    }
}
